/* Add :p_mode to custom-field, kt-com-fld Aug 15, 2024 */
/* Add CustomFields Sep 23, 2023 */
/* Add m_processVoice June 1, 2024 */
/* Add p_mode to custom-field, amend PhoneNoOffice, PhoneNoMobile,otherPhoneNo Aug 24, 2024 */
/* Add  read only columns Jan 25, 2025 */
/* Add Resume data  May 30, 2026 */
/* GUI Changes Phase 1 May 15, 2026 */
/* Add p_appEnt to kt-img-upld */
<template lang="pug">
	<b-tabs>	
	<b-tab title="Team Member">
	<keep-alive>
	div
		rec-wrap(:p_mode="p_mode" :p_saveFn="m_saveFn" p_appEntKey="team" :p_isModal="p_isModal" 
		:p_requiredColumns="d_requiredColumns" :p_recData="d_recData" :p_altView="d_altViewKey" @altViewChg="d_altViewKey = $event" @focused="d_currentFocus = $event" @voice="m_processVoice")
			template(v-slot:rec-form-header)
				div(class="d-flex raisedHeader")
					div(class="form-group"  style="text-align:left;width:20%" )
						//-kt-photo(id="teamPhoto" ref="kt-photo" p_prntRecKey="team" :p_recInfo="c_recInfo" :p_photoRec="c_photoRec")
						kt-img-upld(id="profilePicture" p_defaultIcon="user" :p_currentVal="c_profPicURL" :p_readOnly="p_mode=='view'||m_readOnly('profilePicture')"
						@change="d_recData.profilePictureData_NEW = ($event||'delete');" p_appEnt='team'
						)
					div(class="d-flex flex-column justify-content-center")
						<span class="d-block" style="color:#4fa4ff; font-size:25px;">{{d_recData.teamMemberName}}</span>
						<span v-if="d_recData.role" class="d-block" style="color:#4fa4ff; font-size:18px;">{{d_recData.role}}</span>
			template(v-slot:rec-form-left)
				span <span style="color:#ff9333;">*</span>indicates field is required.
				div(class="form-group")
					label(class="required-label") Team Member #
					b-form-input(class="styled-input" id="teamMemberNo" size="sm"  v-model="d_recData.teamMemberNo" disabled placeholder="Auto Generated")
				div(class="form-group")
					label(class="required-label") Team Member Name
					b-form-input(class="styled-input" id="teamMemberName" size="sm"  v-model="d_recData.teamMemberName" required)
				div(class="form-group")
					label(:class="m_required('role')?'required-label':''") Title/Role
					b-form-input(class="styled-input" id="role" size="sm"  v-model="d_recData.role" )
				div(class="form-group")
					label(:class="m_required('internalEmployeeId')?'required-label':''") Internal Employee Identifier
					b-form-input(class="styled-input" id="internalEmployeeId" size="sm"  v-model="d_recData.internalEmployeeId" )
			template(v-slot:rec-form-right)
				div(class="form-group")
					label(:class="m_required('appUserName')?'required-label':''") Application User Name
					b-input-group-prepend
						b-input-group-text
							fa-icon(icon="user-cog")
						b-form-input(class="styled-input" id="appUserName"  :placeholder="d_recData.appUserName || 'NON USER'"  disabled size="sm")
					span(v-if="!d_recData.appUserName" class="note") Contact application adminstrator to if login access is needed. 
				div(class="form-group")
					label(:class="m_required('phoneNo')?'required-label':''") Phone #s	
					kt-com-fld(id="phoneNo" :p_mode="p_mode" :p_readOnly="m_readOnly('phoneNo')" typ="p" v-model="d_recData.phoneNo" placeholder="Direct")
					kt-com-fld(id="phoneNoOffice" :p_mode="p_mode" :p_readOnly="m_readOnly('phoneNoOffice')" typ="f" v-model="d_recData.phoneNoOffice" placeholder="Office")
					kt-com-fld(id="phoneNoMobile" :p_mode="p_mode" :p_readOnly="m_readOnly('phoneNoMobile')" typ="pm" v-model="d_recData.phoneNoMobile" placeholder="Mobile")
					kt-com-fld(id="faxNo" :p_mode="p_mode" :p_readOnly="m_readOnly('faxNo')" typ="po" v-model="d_recData.faxNo" placeholder="Other phone")
				div(class="form-group")
					label(:class="m_required('email')?'required-label':''") Email
						kt-com-fld(id="email" :p_mode="p_mode" typ="@" :p_readOnly="m_readOnly('email')" v-model="d_recData.email")
				div(class="form-group")
					b-form-checkbox(id="inactive" :value="true" v-model="d_recData.inactive") Inactive
				div(class="form-group")
			template(v-slot:rec-alt-view)
				kt-related(v-if="d_altViewKey=='RR'" :p_relatedGrids="m_relatedGrids()" )
	</keep-alive>
	</b-tab>
		<b-tab title="📜 Resume" style="text-align:left;">
			<keep-alive>
				kt-resume(:value="c_recData" @input="m_updateResume")
			</keep-alive>
		</b-tab>
	</b-tabs>
</template>
<script>
import {fn_getHashId} from "@/utils/util.js";
import {refData,api_baseURL,userSettings} from "@/utils/ref-data.js";
import {fn_saveRecord} from "@/utils/api.js";
import RecWrap from "@/components/RecWrap.vue";
import KTImgUpld from "@/components/Ctrl/KT-ImgUpld.vue";
import KTRelated, {RelatedGridClass, getColFns} from "@/components/Ctrl/KT-Related.vue";
import KTCustomField from "@/components/Ctrl/KT-CustomField.vue";
import KTResume from "@/components/Ctrl/KT-Resume.vue";
export default {
	name: "team-rec",
	components: {
		'rec-wrap': RecWrap,
		'kt-img-upld': KTImgUpld,
		'kt-related': KTRelated,
		'kt-custom-field': KTCustomField,
		'kt-resume': KTResume,
		'kt-photo': () => import("@/components/Ctrl/KT-Photo.vue"),
	},
	created() {
		if (this.p_mode != 'create' && !this.p_recNo) {
			this.d_recNo = fn_getHashId(this);
		}
		else if (this.p_recNo) {
			this.d_recNo = this.p_recNo;
		}
		var usrOpts = userSettings.userOptions;
		this.d_readOnlyColumns=usrOpts['tableReadOnlyColumns']['kt-table-team'];
		this.d_requiredColumns=usrOpts['tableRequiredColumns']['kt-table-team'];
	},
	mounted() {
		console.log('In TeamRec mounted');
		console.log(this.d_recData);
		this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});	
	},
	data() {
		return {
			d_recNo: null,
			d_recData: {},
			d_altViewKey: null,
			d_customFields:refData.customFields.filter(c=>(c.context=='team')),
			d_currentFocus:null,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_certificates:[],
			d_education:[],
			d_requiredFields:[],
		};
	},
	provide() {
    return {vcrec: this}
	},
	props: {
		p_recNo: String,
		p_mode: String,
		p_isModal: Boolean,
	},
	computed: {
		c_recData(){return this.d_recData;},
		c_profPicURL() {
			if (this.d_recData.profilePictureURL)
				return api_baseURL + this.d_recData.profilePictureURL;
			else
				return null;
		},
	c_recInfo() {
      let rd = this.d_recData;
      return {
        Id: rd.teamMemberId,
        No: rd.teamMemberNo,
        Name: rd.teamMemberName,
      };
    },
	c_photoRec() {
			let rd = this.d_recData;
			return {
				photoId: rd.photoId,
				photoURL: api_baseURL + rd.profilePictureURL,
				photoName: rd.photoName
			};
		},
	},
	methods: {
		m_processVoice(e){
			document.getElementById(this.d_currentFocus).value=e;
		},
		m_saveFn() { //Called from  RecWrap, KTList, KTSelect
			let id = this.p_mode == 'edit' ? this.d_recData.teamMemberId : null;
			return fn_saveRecord('teamMember', id, this.d_recData);
		},
		m_relatedGrids() {
			let fIC = {key: 'ic', label: 'Internal Contact', paramNm: 'teamMemberIdIC'};
			let fAO = {key: 'ao', label: 'Account Owner', paramNm: 'teamMemberIdAO'};
			let fAL = {key: 'al', label: 'Activity Lead', paramNm: 'teamMemberIdAL'};
			let fATM = {key: 'atm', label: 'Assigned Team Member', paramNm: 'teamMemberIdATM'};

			let recId = this.d_recData.teamMemberId;
			let recNm = this.d_recData.teamMemberName;

			let roppr = new RelatedGridClass('team', recId, recNm, 'oppr', getColFns.oppr, [fIC, fATM]);
			let rproj = new RelatedGridClass('team', recId, recNm, 'proj', getColFns.proj, [{...fIC}, {...fATM}]); //Need to cpoy
			let racct = new RelatedGridClass('team', recId, recNm, 'acct', getColFns.acct, [fAO, {...fATM}]);
			let rtask = new RelatedGridClass('team', recId, recNm, 'task', getColFns.task, [fAL, {...fATM}]);

			roppr.fn_noValueAggr();
			rproj.fn_noValueAggr();

			return [roppr, rproj, racct, rtask];
		},
		m_readOnly(col){return this.d_readOnlyColumns||[].includes(col);},
		m_required(col){return this.d_requiredColumns||[].includes(col);},
		m_updateResume(event){
			this.d_recData=event;
			var id=this.d_recData.teamMemberId||null;
			return fn_saveRecord('teamMember', id, this.d_recData);
			}
	},
watch: {
		p_mode(nv) {
			if(nv == 'create' || nv=='edit'){
				//- Read Only Columns.
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
			}
		},
  },
  
};

</script>
<style lang="less">
.nav-link.active {
  color: #0f5132   !important;           /* deep green text */
  border-bottom-color: #8fd19e !important; /* soft mint green underline */
  font-weight: 500 !important;
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
.raisedHeader{
	position1:fixed;
	width:1130px;
	padding: 10px;
	background-color: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
	border-radius: 8px;
	z-index1: 9;
	}
.raisedHeader img {
	border-radius: 8px;
}
.raisedHeader .d-flex {
  align-items: center;
}
.nav-link.active {
  color: #0f5132   !important;           /* deep green text */
  border-bottom-color: #8fd19e !important; /* soft mint green underline */
  font-weight: 500 !important;
}
</style>